/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Get_Property_Type, Get_Carpet_Unit} from './Property_Api'
import './propertyNewHome_styles/propertyNewHome.css'
import {FormikValues} from 'formik'
import {propertyTypeDataType, carpetAreaUnitDataType} from './PropertyDataTypes'
import Swal from 'sweetalert2'

const AddPropertyStep1 = ({formik}: FormikValues) => {
  const [propertyType, setPropertyType] = useState<propertyTypeDataType[]>([])
  const [carpetAreaUnit, setCarpetAreaUnit] = useState<carpetAreaUnitDataType[]>([])

  // function to get property type
  async function getPropertyType() {
    try {
      const {data: response} = await Get_Property_Type()
      if (response.code === '200') {
        setPropertyType(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  // function to get carpet area unit
  async function getCarpetAreaUnit() {
    try {
      const {data: response} = await Get_Carpet_Unit()
      if (response.code === '200') {
        setCarpetAreaUnit(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  useEffect(() => {
    getPropertyType()
    getCarpetAreaUnit()
  }, [])

  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*Begin::Form Group property title */}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Property Title</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify your property title'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='property_title'
            placeholder='Enter property title'
            {...formik.getFieldProps('property_title')}
          />
          <div className='h-20px'>
            {formik.touched.property_title && formik.errors.property_title && (
              <div className='fv-help-block color-red'>{formik.errors.property_title}</div>
            )}
          </div>
        </div>
        {/*End::Form Group property title */}
        {/*Begin::Form Group property type */}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Property Type</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose your property type'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            name='property_type_uuid'
            placeholder='Select property type'
            {...formik.getFieldProps('property_type_uuid')}
          >
            <option className='bg-color-gray' value='' disabled>
              Select property type
            </option>
            {propertyType?.map((item: propertyTypeDataType) => {
              return (
                <option key={item.property_type_id} value={item.property_type_uuid}>
                  {item.property_type_name}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.property_type_uuid && formik.errors.property_type_uuid && (
              <div className='fv-help-block color-red'>{formik.errors.property_type_uuid}</div>
            )}
          </div>
        </div>
        {/*End::Form Group property type */}
        {/*Begin::Form Group carpet area */}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Carpet Area</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify carpet area of property'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='carpet_area'
            placeholder='Enter carpet area'
            {...formik.getFieldProps('carpet_area')}
          />
          <div className='h-20px'>
            {formik.touched.carpet_area && formik.errors.carpet_area && (
              <div className='fv-help-block color-red'>{formik.errors.carpet_area}</div>
            )}
          </div>
        </div>
        {/*End::Form Group carpet area */}
        {/*Begin::Form Group carpet area unit*/}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Area Unit</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose unit for carpet area'
            ></i>
          </label>
          <div className='d-flex w-100 gap-10'>
            {/*Begin:Option */}
            <label className='d-flex w-50 flex-fill align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-primary'>
                    <p className='mb-0 display-7 font-weight-bold'>ft²</p>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>{carpetAreaUnit[0]?.carpet_area_unit_name}</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('carpet_area_unit_uuid')}
                  name='carpet_area_unit_uuid'
                  type='radio'
                  value={carpetAreaUnit[0]?.carpet_area_unit_uuid}
                  id='carpet_area_unit_uuid'
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label className='d-flex w-50 flex-fill align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-danger'>
                    <p className='mb-0 display-7 font-weight-bold'>m²</p>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>{carpetAreaUnit[1]?.carpet_area_unit_name}</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('carpet_area_unit_uuid')}
                  name='carpet_area_unit_uuid'
                  type='radio'
                  value={carpetAreaUnit[1]?.carpet_area_unit_uuid}
                  id='carpet_area_unit_uuid'
                />
              </span>
            </label>
            {/*End::Option */}
          </div>
          <div className='h-20px'>
            {formik.touched.carpet_area_unit_uuid && formik.errors.carpet_area_unit_uuid && (
              <div className='fv-help-block color-red'>{formik.errors.carpet_area_unit_uuid}</div>
            )}
          </div>
        </div>
        {/*End::Form Group carpet area unit*/}
      </div>
    </div>
  )
}

export default AddPropertyStep1
